import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO24 = () => {

  return (
    <StaticImage
      src="../../images/JPG-FEMALE-LOOK002-4.jpg"
      title="Reserved avatar"
      alt="Reserved avatar"
    />
  )
}

export default ImageMO24
